import { createEntityAdapter } from '@reduxjs/toolkit';

import { IMediaItem } from './types';

export const mediaItemsAdapter = createEntityAdapter<IMediaItem>({
  selectId: (item) => item.itemId,
});

export const selectors = mediaItemsAdapter.getSelectors();
